import axios from 'axios'

const BASE_URL = '/index'

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 响应拦截
api.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code === 200 || res.code === 0 || response.status === 200) {
      return res.data !== undefined ? res.data : res
    }
    return Promise.reject(new Error(res.msg || '请求失败'))
  },
  error => {
    return Promise.reject(error)
  }
)

// 官网首页数据
export const getHomeData = () => api.get('web/home/')

// 公司信息
export const getCompanyInfo = () => api.get('web/company/')

// 服务列表
export const getServices = (params) => api.get('web/services/', { params })

// 服务详情
export const getServiceDetail = (id) => api.get(`web/services/${id}/`)

// 团队列表
export const getTeamMembers = (params) => api.get('web/team/', { params })

// 团队详情
export const getTeamMemberDetail = (id) => api.get(`web/team/${id}/`)

// 成功案例列表
export const getCases = (params) => api.get('web/cases/', { params })

// 成功案例详情
export const getCaseDetail = (id) => api.get(`web/cases/${id}/`)

// 客户评价
export const getTestimonials = (params) => api.get('web/testimonials/', { params })

// 合作伙伴
export const getPartners = (params) => api.get('web/partners/', { params })

// 新闻列表
export const getNewsList = (params) => api.get('web/news/', { params })

// 新闻详情
export const getNewsDetail = (id) => api.get(`web/news/${id}/`)

// 提交留言
export const submitContact = (data) => api.post('web/contact/', data)

export default api
